import React from 'react';

import Contact from 'components/Contacts/contact';
import ContactBanner from 'components/Contacts/contactBanner';

const ContactPage: React.FC = () => {
  return (
    <>
    <ContactBanner/>
     <Contact/>
    </>
  );
};

export default ContactPage;
